export default "__VITE_ASSET__BU13vVUR__"